import { Injectable, signal } from '@angular/core';
import { VerknüpfungsTyp } from '../../_overlays/zaehlerverwaltung/zaehler.enums';
import { ZaehlerObjektInfo } from '../../_overlays/zaehlerverwaltung/zaehler.types';

@Injectable()
export class ZaehlerStore {
  public readonly verknüpfung = signal<VerknüpfungsTyp>(VerknüpfungsTyp.Hauptzähler);
  public readonly assignedZaehlerName = signal<string>('...');
  public readonly toBeSaved = signal(false);
  public readonly isNew = signal(false);
  public readonly isReadOnly = signal(false);
  public readonly objekt = signal<ZaehlerObjektInfo>(undefined);

  public onSave: (opruefid: number) => Promise<boolean>;
}
